var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"pa-0"},[_c('AllCampaignStatistics',{attrs:{"campaignId":'fd77f60d-6546-4506-92d8-8cb1dcaa19af'}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }